import { Card, InlineStack, Spinner } from "@shopify/polaris";

import * as s from "./ResourceListCard.css";

interface ResourceListCardProps {
  children: React.ReactNode;
}

const ResourceListCard = ({ children }: ResourceListCardProps) => {
  return (
    <div className={s.ResourceListCard}>
      <Card>{children}</Card>
    </div>
  );
};

ResourceListCard.Loader = () => {
  return (
    <ResourceListCard>
      <InlineStack align="center">
        <div className={s.ResourceListCardLoader}>
          <Spinner size="small" />
        </div>
      </InlineStack>
    </ResourceListCard>
  );
};

export { ResourceListCard };
